// extracted by mini-css-extract-plugin
export default {"status":"StatusLabel_status__M34fU","EXPIRED":"StatusLabel_EXPIRED__zHoGY","PAID":"StatusLabel_PAID__i7Ldz","CANCELLED":"StatusLabel_CANCELLED__WNuTp"};